import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
import {useToolbarStyles, useStyles} from './InsumoTableStyles';
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';


function InsumoTable(props) {
  const { insumos, deleteInsumo, editInsumo, setInsumos, atualizarEstoque} = props;


  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [refreshState, setRefreshState] = useState(new Date());
  const [sortSelected, setSortSelected] = useState('0');
  const [sortType] = useState([
    {
      label: 'Descrição',
      value: '0',
      isChecked: false
    },
    {
      label: 'Quantidade',
      value: '1',
      isChecked: false
    }
  ]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    function onChangeSortType(event) {
      setSortSelected(event.target.value);
    }

    function onChooseSortMenu() {
      if(sortSelected === '0'){
        insumos.result = insumos.result.sort(function (a, b) {
          if (a.nome > b.nome) {
            return 1;
          }
          if (a.nome < b.nome) {
            return -1;
          }
          return 0;
        });
        setInsumos(insumos);
      }
      else if(sortSelected === '1'){
        insumos.result = insumos.result.sort(function (a, b) {
          if (a.email > b.email) {
            return 1;
          }
          if (a.email < b.email) {
            return -1;
          }
          return 0;
        });
        setInsumos(insumos);
      }
      else{
        insumos.result = insumos.result.sort(function (a, b) {
          if (a.cpfCnpj > b.cpfCnpj) {
            return 1;
          }
          if (a.cpfCnpj < b.cpfCnpj) {
            return -1;
          }
          return 0;
        });
        setInsumos(insumos);
      }
    }

    return (
      <Toolbar
        className={clsx(classes.root)}
      >
        <Typography className={classes.title} variant="h4" id="tableTitle">
          Insumos
        </Typography>

        <Tooltip title="Ordenação">
          <IconButton
            aria-label="filter list"
            onClick={handleClick}
          >
            <FilterListIcon />
          </IconButton>
        </Tooltip>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <FormControl >
            <RadioGroup value={sortSelected} onChange={onChangeSortType}>
              {sortType.map((sort) => {
                return (
                  <MenuItem
                    onClick={onChooseSortMenu}
                    key={sort.value}
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary" />
                      }
                      label= {sort.label}
                      value={sort.value}

                      labelPlacement="end"
                    />
                  </MenuItem>
                );
              })}
            </RadioGroup>
          </FormControl>

        </Menu>
      </Toolbar>
    );
  };

  function onMouseOveRowTable(event, index) {
    insumos.result[index].on_mouse_over = true;
    setRefreshState(new Date());
  }

  function onMouseLeaveRowTable(event, index) {
    insumos.result[index].on_mouse_over = false;
    setRefreshState(new Date());
  }

  return (
    <Paper className={classes.root}>
      <EnhancedTableToolbar numSelected={0} />
      <TableContainer className={classes.containerTable}>
        <Table
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'label_descricao'}
                align={'left'}
              >
                {'Descrição'}
              </TableCell>

              <TableCell
                key={'label_quantidade'}
                align={'right'}
              >
                {'Quantidade em estoque'}
              </TableCell>

              <TableCell
                key={'label_actions'}
                align={'right'}
                style={{width: '12%'}}
              >
                {''}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {insumos.result.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((insumo, index) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={insumo.idInsumo}
                >
                  <TableCell
                    align={'left'}
                  >
                    {insumo.descricao}
                  </TableCell>
                  <TableCell
                    align={'right'}
                  >
                    {insumo.estoqueInsumo.quantidade}
                  </TableCell>

                  <TableCell
                    align={'right'}
                    style={{width: '20%'}}

                  >
                    <Box
                      component={'div'}
                      display={'inline'}
                      visibility={'visible'}
                    >


                      <IconButton
                        aria-label="editEstoque"
                        className={classes.margin}
                        onClick={e => atualizarEstoque(index)}
                      >
                        <AddIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>

                      <IconButton
                        aria-label="update"
                        className={classes.margin}
                        onClick={e => editInsumo(index)}
                      >
                        <EditIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>
                    </Box>
                    <Box
                      component={'div'}
                      display={'inline'}
                      visibility={'visible'}
                    >
                      <IconButton
                        aria-label="delete"
                        className={classes.margin}
                        onClick={e => deleteInsumo(index)}
                      >
                        <DeleteIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>

              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default InsumoTable;
